module.exports = __webpack_public_path__ + "static/listing-9b68270f8a0c8b44aae1e38686a64f88.jpg";